import { IFreeRoom, ILocation } from "../../Interfaces";

export interface HistoryResponse {
   locations: ILocation[],
    roomspaces: IFreeRoom[],
    roomspaceQuantity: number,
    locationQuantity: number
}

export const defaultHistoryReposnse:HistoryResponse = {
    locations: [],
    roomspaces: [],
    roomspaceQuantity: 0,
    locationQuantity: 0
}